import React, { useEffect, useRef, useState } from 'react';
import CustomDatePickerRange from '../ui/DatePickerRange';
import iconCalendar from '../../images/icon-calendar.svg';
import Select from '../ui/Select';
import CustomDatePicker from "../ui/DatePicker";

export default function TbmCrrStatusList({ tbmStatusView, date, setDate, selectHost, setSelectHost, selectHostData, detailHandler, auth }: any) {
  const [datePopup, setDatePopup] = useState(false);
  const [selectPopup, setSelectPopup] = useState(false);
  const [dateView, setDateView] = useState('');
  const datePopupOpen = () => { setDatePopup(!datePopup); };
  const prodRef = useRef<any>();
  const selectHandler = (data: any) => {

    if (!data) {
      setSelectHost('')
    } else {
      setSelectHost(data.code);
    }

    setSelectPopup(false);
  };

  useEffect(() => {
    let year = date.getFullYear();
    let month: number = date.getMonth() + 1;
    let day = date.getDate();
    setDateView(`${year}. ${month >= 10 ? month : '0' + month}. ${day >= 10 ? day : '0' + day}`);
  }, [date]);

  return (
    <>
      <div className={auth === 'KOX' ? `h-125 md:h-[312px] flex flex-col items-center pt-7 md:pt-[17px]`
        : `h-76 md:h-[190px] flex flex-col items-center pt-7 md:pt-[17px]`}>
        <div onClick={datePopupOpen} ref={prodRef} className='hover:cursor-pointer w-[265px] sm:w-[318px] md:w-[750px] h-43 md:h-[107px] bg-[#2F2F35] flex justify-between items-center rounded-[5px] md:rounded-[12px] mb-14 md:mb-[35px]'>
          <p className='text-14 sm:text-15 md:text-37 font-preBold ml-15 sm:ml-20 md:ml-[50px]'>날짜</p>
          <p className='text-13 sm:text-15 md:text-37 font-preLight w-170 sm:w-[210px] md:w-[525px]'>{dateView}</p>
          <img className='w-16 mr-16 md:w-[40px] md:mr-[40px]' src={iconCalendar} alt='calendar' />
        </div>
        {datePopup
          ? <div className='absolute top-57 md:top-[142px]'>
            <CustomDatePicker date={date} setDate={setDate} setDateView={setDateView} setDatePopup={setDatePopup} prodRef={prodRef} />
          </div>
          : null}
        {auth === 'KOX' &&
          <Select selectHandler={selectHandler} select={selectHost} selectPopup={selectPopup} setSelectPopup={setSelectPopup} selectData={selectHostData} allData>주최</Select>}
      </div>
      <div className={auth === 'KOX' ? `h-[calc(100%-177px)] md:h-[calc(100%-442px)] overflow-auto scrollbar-hide bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center`
        : `h-[calc(100%-128px)] md:h-[calc(100%-320px)] overflow-auto scrollbar-hide bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center`}>
        <div className='mb-20 md:mb-[50px]'>
          <table className='table-fixed w-[265px] sm:w-[318px] md:w-[750px] overflow-auto mt-30 md:mt-[75px]'>
            <tbody>
              <tr className='bg-[#F6F7F9] h-45 md:h-[112px] text-12 sm:text-13 md:text-32 leading-15 md:leading-[37px] text-[#20201D] border border-x-0 border-[#CACACA]'>
                <td className='align-middle text-center w-83 sm:w-87'>업체명</td>
                <td className='align-middle text-center w-56 sm:w-60'>현장대리인 TBM 현황</td>
                <td className='align-middle text-center w-61 sm:w-65 whitespace-pre-line'>작업자{'\n'}이수율</td>
              </tr>
              {tbmStatusView?.length == 0 ?
                <tr className='hover:cursor-pointer h-60 md:h-[150px] text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px] font-preLight border border-x-0 border-t-0 border-[#CACACA]'>
                  <td colSpan={3} className='align-middle text-center'>조회된 데이터가 없습니다.</td>
                </tr>
                : null
              }
              {tbmStatusView?.map((tbm: any, idx: number) => {
                return (
                  <tr key={idx} onClick={() => detailHandler(tbm)} className='hover:cursor-pointer h-60 md:h-[150px] text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px] font-preLight border border-x-0 border-t-0 border-[#CACACA]'>
                    <td className='align-middle text-center'>{tbm.cmpnyNm}</td>
                    <td className='align-middle text-center'>{tbm.siteTbmStat === '미완료' ? <span className='text-point'>미완료</span> : tbm.siteTbmStat}</td>
                    <td className='align-middle text-center whitespace-pre-line'>{tbm.wrkrMngrStat ? tbm.wrkrMngrStat : '-'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

